import { isDarkTheme } from '@/constants/Colors';

const dark = {
  surface: '#141414',
  preview: '#1C1C1C',
  hover: '#202020',
  control: '#262626',
  border: '#2C2C2C',
  activeBorder: '#696969',
  selected: '#232323',
  ink: '#F0F0F0',
  onInk: '#171717',
  icon: '#ADADAD',
};

const light = {
  surface: '#FAFAFA',
  preview: '#F1F1F1',
  hover: '#EDEDED',
  control: '#FFFFFF',
  border: '#E3E3E3',
  activeBorder: '#929292',
  selected: '#F0F0F0',
  ink: '#242424',
  onInk: '#FFFFFF',
  icon: '#686868',
};

export const getCatalogPalette = theme => isDarkTheme(theme) ? dark : light;
